var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBooking = function SvgBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.107.46A.55.55 0 0 1 4.55 1v1.45H6a.55.55 0 0 1 0 1.1H4.55V5a.55.55 0 0 1-1.1 0V3.55H2A.55.55 0 0 1 1.45 3l.01-.107A.55.55 0 0 1 2 2.45h1.45V1A.55.55 0 0 1 4 .45zm-2.88 1.906a1 1 0 0 0-.086.126q.013-.024.027-.047zm2-2a1 1 0 0 0-.086.126q.013-.024.027-.047z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.05,
    d: "M16.875 3.193a.587.587 0 0 1 0 1.176h-5.024a4.48 4.48 0 0 0-3.554 1.755l-1.46 1.908a.6.6 0 0 1-.298.206l-2.844.858a2.79 2.79 0 0 0-1.982 2.669v.454a1.1 1.1 0 0 0 1.1 1.1h2.804a2.838 2.838 0 0 1 5.64 0h5.618a.587.587 0 0 1 0 1.175H11.14a2.839 2.839 0 0 1-5.405 0H2.812A2.275 2.275 0 0 1 .538 12.22v-.454A3.96 3.96 0 0 1 3.355 7.97l2.664-.804L7.363 5.41a5.65 5.65 0 0 1 4.488-2.217zm-8.437 8.77a1.662 1.662 0 1 0-.002 3.325 1.662 1.662 0 0 0 .002-3.325Z"
  })));
};
export default SvgBooking;